import { MaterialIcons } from "@expo/vector-icons";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation, useRoute } from '@react-navigation/core';
import * as Clipboard from 'expo-clipboard';
import React, { useEffect, useState } from 'react';
import { Dimensions, Image, KeyboardAvoidingView, Modal, ScrollView, Text, TouchableOpacity, View, Platform } from 'react-native';
import { TextInput } from 'react-native-paper';
import QRCode from 'react-native-qrcode-svg';

import GradientButton from '../../components/GradientButton';
import HeaderDefault from "../../components/HeaderDefault";
import binanceService from '../../services/binanceService';
import toast from "../../utils/toast";
import { styles } from './styles';

const DepositCrypto = () => {

  const screenSize = Dimensions.get('screen');

  const [modalVisible, setModalVisible] = useState(false);

  const [depositAddress, setDepositAddress] = useState('');
  const [txId, setTxId] = useState('');

  const navigation = useNavigation();
  const route = useRoute();
  const crypto = route.params;

  const [copied, setCopied] = useState(false);
  function copyToClipboard() {
    Clipboard.setString(depositAddress);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  async function pasteClipboard() {
    const clipboard = await Clipboard.getStringAsync();
    setTxId(clipboard);
  }

  function onModalClose() {
    setModalVisible(false);
    navigation.navigate('Home');
  }

  async function registerChashIn() {
    try {
      const authToken = await AsyncStorage.getItem('JWT_TOKEN');
      await binanceService.registerCashInTransaction(authToken, `${crypto.activeId}`, txId, depositAddress);
      setModalVisible(true);
    } catch (err) {
      //console.log(err.response.data);
      if(err.response.data?.message) {
        toast(err.response.data?.message);
      }else{
        toast('Houve um erro ao realizar o depósito.');
      }
    }
  }

  useEffect(() => {
    async function getDepositAddress() {
      try {
        const authToken = await AsyncStorage.getItem('JWT_TOKEN');
        const response = await binanceService.getDepositAddress(authToken, crypto.acronym);
        setDepositAddress(response.data.address);
      } catch (err) {
        console.log(err)
      }
    }
    getDepositAddress();
  }, []);

  return (
    <>
      <KeyboardAvoidingView
        behavior={Platform.OS == "ios" ? "padding" : "height"}
        style={{ flex: 1 }}>
        <HeaderDefault title={`Depositar ${crypto.name}`} />

        <ScrollView style={{ flex: 1 }} contentContainerStyle={styles.container}>
          <View>
            <Text>
              Para depositar o criptoativo, basta transferir da sua carteira {crypto.acronym} a quantidade desejada para a carteira
              destino informada abaixo. A quantidade recebida será detectada automaticamente.
              A quantidade pode demorar algum tempo até ficar disponível para você, o que acontecerá até que a transação seja confirmada.
            </Text>

            <View style={styles.qrCodeContainer}>
              { depositAddress.length > 0 && <QRCode value={`${depositAddress}`} size={screenSize.width*0.3} /> }
            </View>

            <View>
              <View style={styles.spaceBetween}>
                <Text style={styles.textBold}>Código da carteira:</Text>
                <TouchableOpacity onPress={copyToClipboard}>
                  <Text style={styles.copyText}>
                    {copied ? 'Copiado!' : "Copiar"}
                  </Text>
                </TouchableOpacity>
              </View>
              <Text style={styles.contentText}>{depositAddress}</Text>
            </View>

            <View style={styles.txIdInput}>
              <View style={styles.spaceBetween}>
                <Text style={styles.textBold}>Insira o código da transação (tx ID)</Text>
                <TouchableOpacity onPress={pasteClipboard}>
                  <Text style={styles.copyText}>
                    Colar código
                  </Text>
                </TouchableOpacity>
              </View>
              <TextInput 
                value={txId} 
                onChangeText={setTxId} 
                style={styles.contentText} 
                placeholder={'Digite o código da transação'} />
            </View>
          </View>


          {
            txId !== '' &&
            <GradientButton onPress={registerChashIn} >CONTINUAR</GradientButton>
          }
        </ScrollView>

      </KeyboardAvoidingView>
      <Modal
        animationType="slide"
        visible={modalVisible}
        presentationStyle="fullscreen"
        onRequestClose={onModalClose}
        style={styles.modal}
      >
        <View style={styles.modalContainer}>
          <TouchableOpacity onPress={onModalClose} style={styles.modalClose}>
            <MaterialIcons
              name="close"
              size={30}
              color="black"
            />
          </TouchableOpacity>
          <Image style={styles.modalSuccess} source={require('../../../assets/success.png')}></Image>
          <Text style={styles.modalText}>
            Estamos aguardando a sua transferência.
            Assim que ela chegar até nós, o saldo em
            <Text style={styles.textBold}> {crypto.acronym}</Text> será liberado. A quantidade depositada pode demorar algum tempo até ficar disponível para você, o que acontecerá até que a transação seja confirmada.
          </Text>
          <Image resizeMode="contain" style={styles.modalImage} source={require('../../../assets/imgs/cardCoin.png')} />
        </View>
      </Modal>
    </>
  );
}

export default DepositCrypto;